import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { map, catchError } from "rxjs/operators";
import { Uris } from "../../../routes/services/Uris";
import { StorageService } from "../../../routes/services/storage.service";
import { Device, Item, menuDevice, TestConfig } from "../interfaces/interfaces";
import {
  validateCountByPropiety,
  validateCountStatus,
  validateDevices,
  validateStatus
} from "../const";

@Injectable({
  providedIn: "root"
})
export class DeviceFramesDynamicService {
  constructor(
    private http: HttpClient,
    public router: Router,
    public storageService: StorageService
  ) {}

  section_sensor_hydro = "sensors_data";

  getMenuConfig(type: "waterwise" | "feeder"): TestConfig[] {
    const list = {
      waterwise: [
        {
          label: "testing.battery-test",
          icon: "bateria-blanco.svg",
          type_frame: "BATTERY",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: async (query: string) => {
            const res = await this.waterwiseMasiveFrames("battery", query).toPromise();
            return res;
          }
        },
        {
          label: "testing.panel-test",
          icon: "panel-blanco.svg",
          type_frame: "PANEL",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: async (query: string) => {
            const res = await this.waterwiseMasiveFrames("panel", query).toPromise();
            return res;
          }
        },
        {
          label: "testing.request-sensors",
          icon: "",
          type_frame: "WATERWISESENSORSSTATUS",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: async (query: string) => {
            const res = await this.waterwiseMasiveFrames("request_sensors", query).toPromise();
            return res;
          }
        },
        /* {
          label: "testing.request-sensors-hydro",
          icon: "",
          type_frame: "SENSOR_HYDRO_RESPONSE",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: async (query: string) => {
            const res = await this.waterwiseMasiveFrames(
              "sensor_hydro_request_status",
              query
            ).toPromise();
            return res;
          }
        },
          {
          label: "testing.request-version",
          icon: "temporal-blanco.svg",
          type_frame: "VERSION",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) =>
            validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: async (query) => {
            const res = await this.waterwiseMasiveFrames(
              "version",
              query
            ).toPromise();
            return res;
          },
        },
        {
          label: "testing.request-frequency",
          icon: "",
          type_frame: "SENSOR_FREQUENCIES_RESPONSE",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) =>
            validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: async (query: string) => {
            const res = await this.waterwiseMasiveFrames(
              "sensor/frequency/request",
              query
            ).toPromise();
            return res;
          },
        }, */
        {
          label: "testing.turn-on",
          icon: "power-blanco.svg",
          type_frame: "ON",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountByPropiety(item, devices, status, "power", false),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices, "power", true),
          petition: async (query) => {
            const res = await this.waterwiseMasiveFrames("turn_on", query).toPromise();
            return res;
          }
        },
        {
          label: "testing.turn-off",
          icon: "power-off-blanco.svg",
          type_frame: "OFF",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountByPropiety(item, devices, status, "power", true),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices, "power", false),
          petition: async (query) => {
            const res = await this.waterwiseMasiveFrames("turn_off", query).toPromise();
            return res;
          }
        }
      ],
      feeder: [
        {
          label: "testing.battery-test",
          icon: "bateria-blanco.svg",
          type_frame: "BATTERY",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: () => {
            return `gateway/frames/waterwise/{id}/version/`;
          }
        },
        {
          label: "testing.panel-test",
          icon: "panel-blanco.svg",
          type_frame: "PANEL",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: () => {
            return `gateway/frames/waterwise/{id}/version/`;
          }
        },
        {
          label: "testing.turn-on",
          icon: "power-blanco.svg",
          type_frame: "TURN_ON",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices, "power", true),
          petition: () => {
            return `gateway/frames/waterwise/{id}/version/`;
          }
        },
        {
          label: "testing.turn-off",
          icon: "power-off-blanco.svg",
          type_frame: "TURN_OFF",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices, "power", false),
          petition: () => {
            return `gateway/frames/waterwise/{id}/version/`;
          }
        },
        {
          label: "version",
          icon: "temporal-blanco.svg",
          type_frame: "version",
          sent: "",
          countSatus: (item: Item, devices: Device[], status?: string) =>
            validateCountStatus(item, devices, status),
          validateStatus: (item: Item, devices: Device[]) => validateStatus(item, devices),
          validateDevices: (devices: Device[]) => validateDevices(devices),
          petition: () => {
            return `gateway/frames/waterwise/{id}/version/`;
          }
        }
      ]
    };
    return list[type] ? list[type] : [];
  }
  waterwiseMasiveFrames(
    type:
      | "lf_block_on"
      | "lf_block_off"
      | "sensor/frequency/set_hopetitiony"
      | "sensor/frequency/set_3_hours"
      | "sensor/frequency/set_5_hours"
      | "panel"
      | "battery"
      | "sensor_hydro_request_status"
      | "request_sensors"
      | "turn_on"
      | "turn_off"
      | "sensor/frequency/request"
      | "version",
    query,
    body = {}
  ) {
    return this.http
      .post(
        `${Uris.GATEWAYFRAMESWATERWISESMASIVE}${type}/${query}`,
        body,
        this.storageService.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }
}
